import { init as initApm } from "@elastic/apm-rum";

export const apm = initApm({
  serviceName: process.env.NEXT_PUBLIC_ELASTIC_APM_SERVICE_NAME,
  serviceVersion: process.env.NEXT_PUBLIC_ELASTIC_APM_SERVICE_VERSION,
  environment: process.env.NEXT_PUBLIC_ELASTIC_APM_ENVIRONMENT,
  // pageLoadTransactionName: window.location.pathname,
  serverUrl: process.env.NEXT_PUBLIC_ELASTIC_APM_SERVER_URL,
  active: process.env.NEXT_PUBLIC_ELASTIC_APM_ACTIVE === "true",
});

export const captureError = (err: any, message: string) => {
  console.error(err, message);

  apm.captureError(err);
};
